import { Switch } from 'antd'
import React from 'react'

function LoadingToggle() {
  return (
    <Switch className='auf-toggle' loading defaultChecked />
  )
}

export default LoadingToggle